import React, { useState } from "react";
import axios from "axios";
import { API_URL, showAlert } from "../util/api";
import { useNavigate } from "react-router-dom";

import "./provide_email.css";

const ProvideEmail = () => {
  const navigate = useNavigate();

  const [data, setData] = useState({ email: "" });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/provide_email`, data);

      if (response.status === 200 && response.data.status === "successful") {
        showAlert("success", "Success!", response.data.message);
        navigate("/change_password");
      } else {
        showAlert("error", "Error!", response.data.message || "Server error");
      }
    } catch {
      showAlert(
        "error",
        "Error!",
        "Server error! Check your network connection."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
     

      <div className="provide-wrapper">
        <div className="provide-card">

          {/* LEFT PANEL */}
          <div className="provide-left">
            <h1>Password Recovery</h1>
            <p>
              Don’t worry. Enter your registered email address and we’ll help
              you reset your password securely.
            </p>
          </div>

          {/* RIGHT PANEL */}
          <div className="provide-right">
            <h2>Forgot Password</h2>

            <form onSubmit={handleSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  required
                  value={data.email}
                  onChange={(e) =>
                    setData({ ...data, email: e.target.value })
                  }
                />
                <label>Email Address</label>
              </div>

              <button
                type="submit"
                className="submit-btn"
                disabled={loading}
              >
                {loading ? "Processing..." : "Continue"}
              </button>
            </form>

            <div className="helper-text">
              Remembered your password?{" "}
              <span onClick={() => navigate("/login")}>Go back to login</span>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default ProvideEmail;
